'use client';

import { SummitI18nProvider, type SummitTranslator } from '@ctct/summit-core';
import { useTranslations } from 'next-intl';
import { type ReactNode } from 'react';

const asSummitTranslator = (translator: ReturnType<typeof useTranslations>): SummitTranslator =>
  translator as unknown as SummitTranslator;

const SummitI18nNextIntlBridge = ({ children }: { children: ReactNode }) => {
  const tCore = asSummitTranslator(useTranslations('UiCore'));
  const tExtended = asSummitTranslator(useTranslations('UiExtended'));

  return (
    <SummitI18nProvider tCore={tCore} tExtended={tExtended}>
      {children}
    </SummitI18nProvider>
  );
};

export { SummitI18nNextIntlBridge };
